import React, { useState } from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux';
import { datosCompra, Ticket } from '../../../types/types';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { purchaseDeleteDetail } from '../../../api/purchase';
import { fetchDetalleCompra } from '../../../reducer/events-reducer';
import CodigoDescuento from './CodigoDescuento';
import {
    Row,
    Col,
    Button,
} from 'reactstrap';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { getLangValue } from '../../../api/config';

type configObjectEventos = {
    eventsReducer: {
        detalleCompra: datosCompra;
        pasoActualCompra: string;
    }
}

const DetalleCompra = ({ detalleCompra, fetchDetalleCompra, pasoTres, pasoActualCompra, viewComissionText }: { detalleCompra: datosCompra, fetchDetalleCompra:()=> any, pasoTres?:boolean, pasoActualCompra:string, viewComissionText?:boolean }) => {

    const [open, setOpen] = useState(false);
    const [ticket, setTicket] = useState<Ticket | null>(null);
    const [deleting, setDeleting] = useState(false);
    const lang = getLangValue('lang');

    const handleClickOpen = (record:Ticket) => {
        setTicket(record);
        setDeleting(false);
        setOpen(true);
    };

    const handleClose = () => {
        setTicket(null);
        setDeleting(false);
        setOpen(false);
    };

    const handleButtonClick = async() =>{
        if (!ticket || deleting) {
            return;
        }

        setDeleting(true);
        try {
            const res = await purchaseDeleteDetail(ticket.detailCode);
            if (res.result === true) {
                await fetchDetalleCompra();
                let info = res.payload
                if(info) {
                    const eventData = {
                        codigo: info.code, 
                        estatus: info.status,
                        tipo: info.type
                    };
                    const customEvent = new CustomEvent('on_venta_detalle_eliminada', {detail: eventData});
                    document.dispatchEvent(customEvent);
                }
            }
            handleClose();
        } finally {
            setDeleting(false);
        }
    }
    //if(detalleCompra){
    const columns = [
        {
            title: 'Item',
            dataIndex: 'item',
            key: 'item',
        },
        {
            title: 'Sector',
            dataIndex: 'sector',
            key: 'sector',
        },
        {
            title: 'LUGAR',
            dataIndex: 'place',
            key: 'place',
        },
        {
            title: 'Precio',
            dataIndex: 'price',
            key: 'price'
        },
        {
            title: ' ',
            dataIndex: 'delete',
            key: 'delete',
            className: !pasoTres ? 'last-column' : 'last-column-paso-3',
            render: (text:string, record:Ticket) => (
                <>
                    {text}
                    <button onClick={() => handleClickOpen(record)}><ClearOutlinedIcon /></button>
                </>
            ),
        },
    ];

    const data = detalleCompra.tickets.map((ticket, index) => ({
        ...ticket,
        key: index.toString(),
    }));
    //}

    return (
        <div>
            <h4 className='subtitles' style={{"textAlign":"center"}}>Detalle de tu Compra</h4>
            {detalleCompra && <>
                <Dialog 
                    open={open} 
                    onClose={handleClose} 
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{"zIndex": 9999}}>
                        <DialogTitle id="alert-dialog-title" className='text-center'>
                            <b>{"Eliminar Item"}</b>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                            Realmente deseas eliminar este Item de la Compra?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions style={{justifyContent: 'center'}}>
                            <Button className='back_2' onClick={handleClose}>Cancelar</Button>
                            <Button onClick={handleButtonClick} disabled={deleting} autoFocus>
                                Aceptar
                            </Button>
                        </DialogActions>
                </Dialog>
                <Table className='detalle-compra-table' columns={columns} dataSource={data} pagination={false} />
                {!pasoTres && <>
                    <Row className='total-detalle-compra pt-2 pb-2'>
                        <Col xs={3} className='ps-1'>{detalleCompra.ticketsQuantity > 1 ? 'ITEMS' : 'ITEM'}</Col>
                        <Col xs={3} className='ps-4'> {detalleCompra.ticketsQuantity} </Col>
                        <Col xs={3}>TOTAL</Col>
                        <Col xs={3} className='pr-4'>{detalleCompra.totalTickets}</Col>
                    </Row>
                    {detalleCompra.amountDiscount < 0 && <>
                        <Row className='total-detalle-compra pt-2 pb-2'>
                            <Col xs={3}> </Col>
                            <Col xs={3} className='ps-2'> {detalleCompra.discountName} </Col>
                            <Col xs={3}></Col>
                            <Col xs={3}>{detalleCompra.totalDiscount}</Col>
                        </Row>
                    </>}
                </>}
                {pasoTres  && <>
                    <Row className='total-detalle-compra pt-2 pb-2'>
                        <Col xs={8} className='ps-1'> SubTotal (por cuenta y orden) </Col>
                        <Col xs={4} className='text-end'> {detalleCompra.totalTickets} </Col>
                    </Row>
                    {detalleCompra.commissionWithDiscount === "" &&
                        <Row className='total-detalle-compra pt-2 pb-2'>
                            <Col xs={6} className='ps-1'> Servicio Venta Internet {lang === 'es_AR' && (pasoActualCompra != "4" || viewComissionText) && (detalleCompra.commission != "$ 0,00") && <><br/><small>(este cargo puede variar según el medio de pago)</small></>}</Col>
                            <Col xs={6} className='text-end'> {detalleCompra.commission} </Col>
                        </Row>
                    }

                    {detalleCompra.amountDiscount < 0 && <>
                        <Row className='total-detalle-compra pt-2 pb-2'>
                            <Col xs={6} className='ps-1'> {detalleCompra.discountName} </Col>
                            <Col xs={6} className='text-end'>{detalleCompra.totalDiscount}</Col>
                        </Row>
                    </>}
                    {detalleCompra.commissionWithDiscount !== "" &&
                        <Row className='total-detalle-compra pt-2 pb-2'>
                            <Col xs={6} className='ps-1'> Servicio Venta Internet {lang === 'es_AR' && (pasoActualCompra != "4" || viewComissionText) && (detalleCompra.commission != "$ 0,00") && <><br/><small>(este cargo puede variar según el medio de pago)</small></>}</Col>
                            <Col xs={6} className='text-end'> {detalleCompra.commissionWithDiscount} </Col>
                        </Row>
                    }
                    <Row className='total-detalle-compra pt-2 pb-2'>
                        <Col xs={6} className='ps-1'> TOTAL </Col>
                        <Col xs={6} className='text-end'> {detalleCompra.totalToPaid} </Col>
                    </Row>
                </>}
                {detalleCompra.hasPromoElective && detalleCompra.ticketsQuantity > 0 && detalleCompra.amountDiscount === 0 && pasoActualCompra === "2" && <CodigoDescuento />}
                </>
            }
        </div>
    );
};

const mapStateToProps = (state: configObjectEventos) => {
    return {
        detalleCompra: state.eventsReducer.detalleCompra,
        pasoActualCompra: state.eventsReducer.pasoActualCompra,
    }
}

export default connect(
    mapStateToProps,
    {fetchDetalleCompra}
)(DetalleCompra);
